// ServiceManager.js
import Vue from "vue";
import { SERVICE_ACTIONS_ENUM } from "@/enums/gmb-services.enum";
import ItemIndexFinder from "@/helpers/gmbServices/item-index-finder";

class SelectedServicesManager {
  constructor(selectedServices) {
    this.selectedServices = selectedServices;
  }

  updateServiceItems({ item: updatedItem, action }) {
    const index = this.findServiceItemIndex(updatedItem);
    const updatedService = this.createUpdatedService(updatedItem, action);

    if (index !== -1) {
      this.updateExistingService(index, updatedService, action);
    } else {
      this.addNewService(updatedService);
    }
  }

  findServiceItemIndex(updatedItem) {
    return ItemIndexFinder.getUpdateServiceItemIndex(
      this.selectedServices,
      updatedItem
    );
  }

  createUpdatedService(updatedItem, action) {
    return {
      ...updatedItem,
      selected: true,
      deleted: action === SERVICE_ACTIONS_ENUM.DELETE
    };
  }

  updateExistingService(index, updatedService, action) {
    Vue.set(this.selectedServices, index, {
      ...updatedService,
      deleted: action === SERVICE_ACTIONS_ENUM.DELETE
    });
  }

  addNewService(updatedService) {
    this.selectedServices.push(updatedService);
  }
}

export default SelectedServicesManager;
